<template>
  <ul 
    v-if="!loading"
    :class="{'internal-next-pages--isTouch': touch}"
    class="internal-next-pages">
    <li 
      v-if="services"
      class="internal-next-pages__item">
      <router-link :to="{ name: `${lang}.single-page`, params: { slug: $_getPageSlug('Services') } }">
        <div class="internal-next-pages__item__absolute-block">
          <h4 v-html="$t('internalNextPages.servicesTitle')"></h4>
          <p v-html="$t('internalNextPages.servicesContent')"></p>
          <span v-html="$t('internalNextPages.servicesLink')"></span>
        </div>
      </router-link>
    </li>
    <li 
      v-if="quality"
      class="internal-next-pages__item">
      <router-link :to="{ name: `${lang}.single-page`, params: { slug: $_getPageSlug('Quality') } }">
        <div class="internal-next-pages__item__absolute-block">
          <h4 v-html="$t('internalNextPages.qualityTitle')"></h4>
          <p v-html="$t('internalNextPages.qualityContent')"></p>
          <span v-html="$t('internalNextPages.qualityLink')"></span>
        </div>
      </router-link>
    </li>
    <li 
      v-if="company"
      class="internal-next-pages__item">
      <router-link :to="{ name: `${lang}.single-page`, params: { slug: $_getPageSlug('Company') } }">
        <div class="internal-next-pages__item__absolute-block">
          <h4 v-html="$t('internalNextPages.companyTitle')"></h4>
          <p v-html="$t('internalNextPages.companyContent')"></p>
          <span v-html="$t('internalNextPages.companyLink')"></span>
        </div>
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import getSinglePages from '@/mixins/getSinglePages.js'

export default {
  name: 'InternalNextPages',
  mixins: [getSinglePages],
  props: {
    services: {
      type: Boolean,
      default: false
    },
    quality: {
      type: Boolean,
      default: false
    },
    company: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'touch',
      'lang'
    ])
  }
}
</script>

<style lang="scss">
  @import "./internal-next-pages.scss";
</style>
  